import { render, staticRenderFns } from "./newShenheModal.vue?vue&type=template&id=bdfd4744&scoped=true"
import script from "./newShenheModal.vue?vue&type=script&lang=js"
export * from "./newShenheModal.vue?vue&type=script&lang=js"
import style0 from "./newShenheModal.vue?vue&type=style&index=0&id=bdfd4744&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfd4744",
  null
  
)

export default component.exports